import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getJDepartmentList } from '@/service/components'

// 与 getJPositionListSlice.processSingleDataType 一致：option → value + label → SelectC
const processSingleDataType = ({ data, dataType }) => {
  let list = data
  if (list && !Array.isArray(list)) {
    if (Array.isArray(list.records)) {
      list = list.records
    } else if (Array.isArray(list.data)) {
      list = list.data
    }
  }
  if (!Array.isArray(list)) return []

  if (!dataType || dataType === 'default') {
    return list
  }

  switch (dataType) {
    case 'option':
      return list.map((item) => ({
        id: `${item.value}`,
        value: item.label
      }))
    default:
      return list
  }
}

// ==================== 初始状态 ====================

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: []
}

// ==================== 异步 Actions ====================

export const fetchJDepartmentList = createAsyncThunk(
  'getJDepartmentList/fetchJDepartmentList',
  async ({ query = {}, dataType } = {}, { rejectWithValue }) => {
    try {
      const response = await getJDepartmentList(query)
      return {
        data: response.data,
        query,
        dataType
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取部门列表失败')
    }
  }
)

// ==================== Slice ====================

const getJDepartmentListSlice = createSlice({
  name: 'getJDepartmentList',
  initialState: defaultState,
  reducers: {
    resetJDepartmentListState: (state) => {
      state.query = {}
      state.data = []
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJDepartmentList.pending, (state, action) => {
        state.fetching = true
        state.error = null
        const arg = action.meta?.arg || {}
        state.query = arg.query || {}
        state.data = []
      })
      .addCase(fetchJDepartmentList.fulfilled, (state, action) => {
        const { data, dataType, query } = action.payload || {}
        state.fetching = false
        state.error = null
        state.query = query || {}
        state.data = processSingleDataType({ data, dataType })
      })
      .addCase(fetchJDepartmentList.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload
        state.data = []
      })
  }
})

export const { resetJDepartmentListState } = getJDepartmentListSlice.actions
export default getJDepartmentListSlice.reducer
